import { keepPreviousData, queryOptions } from '@tanstack/react-query'
import { Request } from 'commons/utils/request'

import { AlertsPayload, AlertsResponse } from './types'

export const ALERTS_KEY = 'alerts'

export const alertsQueryOptions = (deps: Partial<AlertsPayload>) =>
  queryOptions({
    queryKey: [ALERTS_KEY, deps],
    queryFn: () => Request.post<AlertsResponse, Partial<AlertsPayload>>(Request.urls.bank.alertsView, { ...deps }),
    structuralSharing: true,
    staleTime: 1000,
    placeholderData: keepPreviousData
  })
